import { useContext, useEffect } from 'react'

import AppContext from '@/context/AppContext'

import { getProcessSteps } from './helpers'

const useProcessSteps = () => {
  const { context, setContext } = useContext(AppContext)

  useEffect(() => {
    const processSteps = getProcessSteps({
      portalType: context.merchantInfo.preferences.portal_type,
      orderType: context.orderInfo.type,
      summaryTotalAmount: context.orderAmount.summary_total_amount,
      isRefundStepSkipped: context.orderInfo.isRefundStepSkipped,
    })

    setContext(context => ({ ...context, processSteps }))
  }, [
    context.orderAmount.summary_total_amount,
    context.orderInfo.type,
    context.orderInfo.isRefundStepSkipped,
    context.merchantInfo.preferences.portal_type,
    setContext,
  ])

  return { steps: context.processSteps }
}

export default useProcessSteps
